import { defineMessages } from "react-intl"

export default defineMessages({
  passwordRule: {
    id: "form.register.error.passwordrule",
    defaultMessage:
      "Passwords must be at least 8 characters long with at least 1 number, 1 special and 1 capital letter"
  },
  passwordMismatch: {
    id: "form.register.error.passwordmatch",
    defaultMessage: "both password do not match"
  }
})
